module.exports = __webpack_public_path__ + "static/img/15-深圳中学.cc9ca404.png";